import BaseLayer from "./BaseLayer";
import {drawVector} from "../utils/map_utils";
import {hsvToRgb, notNull} from "../../../utils/utils";

/**
 * Per-seam residual DIRECTION (dx, dy) drawn as an arrow at each seam centre.
 * Arrow length is scaled so the largest residual reaches ~0.45 tile, since the
 * raw residual is sub-pixel and otherwise invisible at slide scale.
 */
class SeamDistortionVector extends BaseLayer {
    id = "seamDistortionVec";
    label = "Seam Dist Vec";
    defaultVisible = this.props.tileViewerState[this.id];

    colorFor = (mag, maxV) => {
        let frac = maxV > 0 ? Math.max(0, Math.min(1, mag / maxV)) : 0;
        let {r, g, b} = hsvToRgb(0.33 * (1 - frac), 1, 1);
        return `rgba(${r},${g},${b},0.95)`;
    };

    draw = () => new Promise((resolve) => {
        let {seamDistortion, slide, textColor} = this.props;
        if (!notNull(seamDistortion)) return resolve();

        let {tile_width, tile_height, uperpixel, y_fields} = slide;
        let tw = tile_width * uperpixel, th = tile_height * uperpixel;

        let stats = seamDistortion.stats || {};
        let maxV = notNull(stats.p95) ? stats.p95 : (notNull(stats.max) ? stats.max : 1);
        // pixels of residual -> map microns, so maxV residual spans ~0.45 tiles
        let arrowScale = (0.45 * th) / (maxV > 0 ? maxV : 1);

        let plot = (mapObj, isTop) => {
            Object.entries(mapObj || {}).forEach(([key, val]) => {
                let x = parseInt(key.split('y')[0].split('x')[1]);
                let y = parseInt(key.split('y')[1]);
                if (isNaN(x) || isNaN(y)) return;
                let yV = y_fields - y - 1;
                let cx = isTop ? (x + 0.5) * tw : x * tw;
                let cy = isTop ? (yV + 1) * th : (yV + 0.5) * th;
                let vx = val.dx_px * arrowScale;
                let vy = val.dy_px * arrowScale;
                drawVector(cx, cy, vx, vy, this.layer.getSource(),
                    this.colorFor(val.mag_px, maxV), 2,
                    `${val.dx_px},${val.dy_px}px`, textColor);
            });
        };

        plot(seamDistortion.top, true);
        plot(seamDistortion.left, false);
        resolve();
    });
}

export default SeamDistortionVector;
